import { formatPattern } from "react-router-utils";
import Button from "app/components/UI/Button";
import Flex from "app/components/UI/Flex";
import Icon from "app/components/UI/Icon";
import Link from "app/components/UI/Link";
import PropTypes from "prop-types";
import React from "react";
import Title from "app/components/UI/Title";
import classes from "./EmptyCart.module.css";

export const EmptyCart = ({ translate, clubId }) =>
  <div className={classes.pageContainer}>
    <Title component="h2">
      {translate("Votre Panier")}
    </Title>

    <Flex direction="column" middle>
      <Icon className={classes.emptyCart__icon}>shopping_cart</Icon>
      <p className={classes.emptyCart__text}>
        {translate("Votre Panier est vide !")}
      </p>
      <Link className={classes.emptyCart__link} to={formatPattern("/:clubId/shop", { clubId: clubId })}>
        <Button fullWidth label={translate("Revenir à la boutique")} />
      </Link>
    </Flex>
  </div>;

EmptyCart.propTypes = {
  translate: PropTypes.func.isRequired,
  clubId: PropTypes.string.isRequired
};

export default EmptyCart;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutCart/EmptyCart/EmptyCart.js